module.exports = __webpack_public_path__ + "img/分组 26-3.bfccffeb.png";